const init = () => {
  const globalData = require('./globalData');
  const eventBus = require('./eventBus');
  const $win = $(window);
  $win.on('resize', () => {
    const [width, height] = [$win.width(), $win.height()];
    globalData.set('windowSize', {width, height});
    eventBus.trigger('resize');
  });
};
module.exports = {init};